import { createContext, useCallback, useContext, useEffect, useState } from 'react'
import currencyCatalogService from '../services/currencyCatalogService'

const fallbackCurrencyCatalog = currencyCatalogService.getCurrencyCatalogFallback()
const fallbackCatalog = {
  ...fallbackCurrencyCatalog,
  error: null,
  loading: false,
}

const CurrencyCatalogContext = createContext({
  ...fallbackCatalog,
  refresh: async () => fallbackCatalog,
})

export function CurrencyCatalogProvider({ children }) {
  const [catalog, setCatalog] = useState(fallbackCatalog)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const loadCatalog = useCallback(async () => {
    setLoading(true)
    setError(null)

    try {
      const nextCatalog = await currencyCatalogService.getCurrencyCatalog()
      setCatalog({
        currencies: Array.isArray(nextCatalog.currencies) && nextCatalog.currencies.length > 0
          ? nextCatalog.currencies
          : fallbackCurrencyCatalog.currencies,
        source: nextCatalog.source || 'shared/currencies.json',
        count: Number(nextCatalog.count || nextCatalog.currencies?.length || fallbackCurrencyCatalog.count),
      })
      return nextCatalog
    } catch (loadError) {
      console.warn('[currency_catalog] failed to load shared currencies', loadError)
      setError(loadError?.message || 'Failed to load currency catalog')
      setCatalog(fallbackCatalog)
      return fallbackCatalog
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void loadCatalog()
  }, [loadCatalog])

  return (
    <CurrencyCatalogContext.Provider
      value={{
        ...catalog,
        loading,
        error,
        refresh: loadCatalog,
      }}
    >
      {children}
    </CurrencyCatalogContext.Provider>
  )
}

export function useCurrencyCatalog() {
  return useContext(CurrencyCatalogContext)
}
